import React, { useEffect, useState, useRef, useMemo } from "react";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Wordcloud from 'highcharts/modules/wordcloud';
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { Ripple } from "primereact/ripple";
import { ProgressSpinner } from "primereact/progressspinner";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { utils } from "../../../utils/index";
import EventEmitter, { Events } from "../../../services/eventemitter";
import { t } from "i18next";
import "../menu.css";
import { LoginResponse } from "../../../models/index";
import RightSideBar from "./RightsideBar";

Wordcloud(Highcharts); // Initialize wordcloud module

const InsightsReport = () => {
    var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [WebsiteArray, setWebsiteArray] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [exportloading, setExportLoading] = useState(false);
    const [refreshState, setRefreshState] = useState<any>(new Date());
    const [loadingWebsite, setLoadingWebsite] = useState(true);
    const [extractedKey, setExtractedKey] = useState<any>("");
    const [selectedHeading, setSelectedHeading] = useState<string | null>(null);
    const [visiblesidebar, setVisibleSidebar] = useState<boolean>(false);
    const [selecteddate, setselecteddate] = useState<Date | Date[] | undefined>(undefined);
    const [getreport, setGetReport] = useState<any>([]);
    const [getchatID, setGetChatID] = useState<any>([]);
    const [trendingKeyword, setTrendingkeyword] = useState(t("GraphReports-label.Trending-Keywords"));
    const [manageState, setManageState] = useState(false);

    useEffect(() => {
        EventEmitter.on(Events.changelayOutMode, toggleDarkMode);
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, []);

    const toggleDarkMode = () => {
        setTrendingkeyword("");
        setRefreshState(new Date()?.getTime());
        setTrendingkeyword(t("GraphReports-label.Trending-Keywords"));
        setManageState(true);
        setTimeout(() => {
            setManageState(false);
        }, 1);
    };
    const forceFullyChangeLanguage = () => {
        setTrendingkeyword("");
        setRefreshState(new Date()?.getTime());
        setTrendingkeyword(t("GraphReports-label.Trending-Keywords"));
        setManageState(true);
        setTimeout(() => {
            setManageState(false);
        }, 1);
    };

    useEffect(() => {
        ApiCalls();
        BotAnalysisAPi();
    }, []);

    const ApiCalls = async () => {
        loadWebsites();
    };

    const ExportPDF = async () => {
        setExportLoading(true);
        const element = document.getElementById("insight-report");
        if (element) {
            const pdf = new jsPDF();
            const sectionIds = ["section1"];
            const logoWidth = 100;
            const logoHeight = 36;
            const logoX = 90;
            let contentY = 5; // Start content at the top of the page

            for (let i = 0; i < sectionIds.length; i++) {
                const sectionId = sectionIds[i];
                var section = document.getElementById(sectionId);
                if (i > 0) {
                    pdf.addPage();
                    contentY = 10; // Reset content position for new page
                }

                // Add Logo
                if (sectionId === "section1") {
                    const imageElement = document.getElementById("logoImage");
                    const imgDataUrl = imageElement?.getAttribute("src") || "";
                    const canvasLogo = document.createElement("canvas");
                    const ctxLogo = canvasLogo.getContext("2d");

                    if (ctxLogo) {
                        const imgLogo = new Image();
                        imgLogo.src = imgDataUrl;
                        await new Promise((resolve) => {
                            imgLogo.onload = () => {
                                ctxLogo.drawImage(imgLogo, 0, 10, logoWidth, logoHeight);
                                resolve(null);
                            };
                        });
                        const logoDataUrl = canvasLogo.toDataURL("image/png");
                        pdf.addImage(logoDataUrl, "PNG", logoX, contentY, logoWidth, logoHeight);
                        contentY += logoHeight - 18; // Adjust content position below the logo
                    }
                }

                // Add Heading Text
                const textImageElement = document.getElementById("textImage");
                if (textImageElement) {
                    const textSpans = textImageElement.querySelectorAll(".wgreport-span");
                    pdf.setFontSize(12); // Set heading font size
                    pdf.setTextColor(0, 0, 0); // Set text color (black)

                    textSpans.forEach((span) => {
                        const textContent = span.textContent || "";
                        const pageWidth = pdf.internal.pageSize.getWidth(); // Get the PDF page width
                        const textWidth = pdf.getTextWidth(textContent); // Get the width of the text
                        const x = (pageWidth - textWidth) / 2; // Calculate the X position to center the text
                        pdf.text(textContent, x, contentY);
                        contentY += 6; // Adjust Y position for the next line of text
                    });
                    contentY -= 5;
                }

                // Add Section Content

                if (section) {
                    const canvas = await html2canvas(section, {
                        scale: 2, // Improve rendering quality
                    });
                    // const canvas = await html2canvas(section);
                    const imgData = canvas.toDataURL("image/png");
                    const sectionWidth = pdf.internal.pageSize.getWidth() - 10;
                    const sectionHeight = 250;

                    pdf.addImage(imgData, "PNG", 10, contentY, sectionWidth, sectionHeight);
                    contentY += sectionHeight + 10; // Adjust position for the next section
                }
            }

            pdf.save("Chats AI Insights Report.pdf");
        }
        setExportLoading(false);
    };

    const submit = () => {
        if (!selecteddate) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, "Please select date");
            return;
        }
        if (!selectedWebsite) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t("toast.website-validtion"));
            return;
        } else {
            setLoading(true);
            BotAnalysisAPi();
        }
    };
    const loadWebsites = async () => {
        let response = await wglcsApiService.getwebsitesbyempCompany(userData?.userLoginData?.empCompId);
        var data = utils.arraySorting('domainName', response.data.data)
        setWebsiteArray(data);
        setLoadingWebsite(false);
    };
    const WebsiteOptionTemplate = (option) => {
        if (loadingWebsite) {
            return (
                <div style={{ margin: "2px" }}>
                    <Skeleton></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.domainName}</div>
                </div>
            );
        }
    };

    const onWebsiteChange = (e) => {
        setSelectedWebsite(e.value);
    };

    const BotAnalysisAPi = async () => {
        // var date_: any = selecteddate;
        // const formattedDate = moment(date_).format("YYYY-MM-DD");
        // var params = {
        //     monthDate: formattedDate,
        //     websiteId: selectedWebsite.websiteId,
        // };
        const data = [
            {
                "167": {
                    "trending_keywords": {
                        "data": [
                            {
                                "data": "email",
                                "chats": [
                                    {
                                        "chat_id": "23898248",
                                        "billable": true,
                                        "chatStartTime": "2025-04-30T17:56:27.76"
                                    },
                                    {
                                        "chat_id": "23902062",
                                        "billable": true,
                                        "chatStartTime": "2025-05-01T21:23:39.073"
                                    },
                                    {
                                        "chat_id": "23907584",
                                        "billable": false,
                                        "chatStartTime": "2025-05-04T06:51:52.89"
                                    },
                                    {
                                        "chat_id": "23928061",
                                        "billable": true,
                                        "chatStartTime": "2025-05-11T18:24:35.427"
                                    },
                                    {
                                        "chat_id": "23935146",
                                        "billable": true,
                                        "chatStartTime": "2025-05-13T20:43:58.8"
                                    }
                                ],
                                "count": 5
                            },
                            {
                                "data": "phone",
                                "chats": [
                                    {
                                        "chat_id": "23898248",
                                        "billable": true,
                                        "chatStartTime": "2025-04-30T17:56:27.76"
                                    },
                                    {
                                        "chat_id": "23902062",
                                        "billable": true,
                                        "chatStartTime": "2025-05-01T21:23:39.073"
                                    },
                                    {
                                        "chat_id": "23907584",
                                        "billable": false,
                                        "chatStartTime": "2025-05-04T06:51:52.89"
                                    }
                                ],
                                "count": 3
                            },
                            {
                                "data": "trade-in",
                                "chats": [
                                    {
                                        "chat_id": "23907132",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:19:44.437"
                                    },
                                    {
                                        "chat_id": "23907138",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:24:12.107"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "financing",
                                "chats": [
                                    {
                                        "chat_id": "23907012",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T21:41:51.547"
                                    },
                                    {
                                        "chat_id": "23907132",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:19:44.437"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "appointment",
                                "chats": [
                                    {
                                        "chat_id": "23907584",
                                        "billable": false,
                                        "chatStartTime": "2025-05-04T06:51:52.89"
                                    },
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "car",
                                "chats": [
                                    {
                                        "chat_id": "23947315",
                                        "billable": false,
                                        "chatStartTime": "2025-05-17T16:08:27.213"
                                    },
                                    {
                                        "chat_id": "23949247",
                                        "billable": false,
                                        "chatStartTime": "2025-05-18T15:06:12.547"
                                    },
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    },
                                    {
                                        "chat_id": "23954864",
                                        "billable": true,
                                        "chatStartTime": "2025-05-20T12:42:51.297"
                                    },
                                    {
                                        "chat_id": "23955499",
                                        "billable": false,
                                        "chatStartTime": "2025-05-20T15:31:55.86"
                                    },
                                    {
                                        "chat_id": "23956615",
                                        "billable": false,
                                        "chatStartTime": "2025-05-20T20:17:01.947"
                                    },
                                    {
                                        "chat_id": "23959457",
                                        "billable": true,
                                        "chatStartTime": "2025-05-21T17:04:29.177"
                                    }
                                ],
                                "count": 7
                            },
                            {
                                "data": "trade",
                                "chats": [
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    },
                                    {
                                        "chat_id": "23954911",
                                        "billable": true,
                                        "chatStartTime": "2025-05-20T13:02:55.52"
                                    },
                                    {
                                        "chat_id": "23955499",
                                        "billable": false,
                                        "chatStartTime": "2025-05-20T15:31:55.86"
                                    },
                                    {
                                        "chat_id": "23963808",
                                        "billable": false,
                                        "chatStartTime": "2025-05-22T21:37:49.787"
                                    }
                                ],
                                "count": 4
                            },
                            {
                                "data": "service",
                                "chats": [

                                ],
                                "count": 0
                            }
                        ],
                        "representation": 5,
                        "title": "Most Common Visitor Keywords"
                    },
                    "frequently_asked_questions": {
                        "data": [
                            {
                                "data": "What are the dealer's hours?",
                                "chats": [
                                    {
                                        "chat_id": "23898248",
                                        "billable": true,
                                        "chatStartTime": "2025-04-30T17:56:27.76"
                                    },
                                    {
                                        "chat_id": "23905049",
                                        "billable": true,
                                        "chatStartTime": "2025-05-02T23:12:03.3"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "Are you open on Sundays?",
                                "chats": [
                                    {
                                        "chat_id": "23907577",
                                        "billable": true,
                                        "chatStartTime": "2025-05-04T06:43:44.987"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "How much would you offer me for my car?",
                                "chats": [
                                    {
                                        "chat_id": "23904754",
                                        "billable": true,
                                        "chatStartTime": "2025-05-02T20:44:54.903"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "What type of warranty comes with your used vehicles?",
                                "chats": [
                                    {
                                        "chat_id": "23924607",
                                        "billable": true,
                                        "chatStartTime": "2025-05-09T21:13:07.087"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "How much do you charge for an oil change?",
                                "chats": [
                                    {
                                        "chat_id": "23939351",
                                        "billable": true,
                                        "chatStartTime": "2025-05-15T00:31:29.683"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "how much?",
                                "chats": [
                                    {
                                        "chat_id": "23952121",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T16:08:45.11"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "are you open on next monday?",
                                "chats": [
                                    {
                                        "chat_id": "23959517",
                                        "billable": false,
                                        "chatStartTime": "2025-05-21T17:18:42.76"
                                    },
                                    {
                                        "chat_id": "23959518",
                                        "billable": false,
                                        "chatStartTime": "2025-05-21T17:18:52.06"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "do you have rentals?",
                                "chats": [
                                    {
                                        "chat_id": "23959457",
                                        "billable": true,
                                        "chatStartTime": "2025-05-21T17:04:29.177"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "can I get a car?",
                                "chats": [
                                    {
                                        "chat_id": "23963648",
                                        "billable": false,
                                        "chatStartTime": "2025-05-22T20:35:52.58"
                                    }
                                ],
                                "count": 1
                            }
                        ],
                        "representation": 2,
                        "title": "Most Frequently Asked Questions"
                    },
                    "customer_pain_points": {
                        "data": [
                            {
                                "data": "bad credit",
                                "chats": [
                                    {
                                        "chat_id": "23907132",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:19:44.437"
                                    },
                                    {
                                        "chat_id": "23907138",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:24:12.107"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "vehicle not starting",
                                "chats": [
                                    {
                                        "chat_id": "23903703",
                                        "billable": true,
                                        "chatStartTime": "2025-05-02T14:45:13.807"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "disconnection issues",
                                "chats": [
                                    {
                                        "chat_id": "23907138",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:24:12.107"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "price discrepancies",
                                "chats": [
                                    {
                                        "chat_id": "23909256",
                                        "billable": true,
                                        "chatStartTime": "2025-05-05T03:02:15.713"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "service availability",
                                "chats": [

                                ],
                                "count": 0
                            },
                            {
                                "data": "car cranks but won’t start",
                                "chats": [

                                ],
                                "count": 0
                            },
                            {
                                "data": "service wait time",
                                "chats": [
                                    {
                                        "chat_id": "23986646",
                                        "billable": false,
                                        "chatStartTime": "2025-05-30T16:46:14.707"
                                    }
                                ],
                                "count": 1
                            }
                        ],
                        "representation": 2,
                        "title": "Customer Pain Points"
                    },
                    "follow_up_preferences": {
                        "data": [
                            {
                                "data": "email",
                                "chats": [
                                    {
                                        "chat_id": "23898248",
                                        "billable": true,
                                        "chatStartTime": "2025-04-30T17:56:27.76"
                                    },
                                    {
                                        "chat_id": "23910687",
                                        "billable": true,
                                        "chatStartTime": "2025-05-05T15:32:49.4"
                                    },
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    }
                                ],
                                "count": 3
                            },
                            {
                                "data": "phone",
                                "chats": [
                                    {
                                        "chat_id": "23898248",
                                        "billable": true,
                                        "chatStartTime": "2025-04-30T17:56:27.76"
                                    },
                                    {
                                        "chat_id": "23907132",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:19:44.437"
                                    },
                                    {
                                        "chat_id": "23954864",
                                        "billable": true,
                                        "chatStartTime": "2025-05-20T12:42:51.297"
                                    },
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    }
                                ],
                                "count": 4
                            }
                        ],
                        "representation": 6,
                        "title": "Visitor Follow-Up Preferences"
                    },
                    "most_asked_vehicles": {
                        "data": [
                            {
                                "data": "Chevy",
                                "chats": [
                                    {
                                        "chat_id": "23898248",
                                        "billable": true,
                                        "chatStartTime": "2025-04-30T17:56:27.76"
                                    },
                                    {
                                        "chat_id": "23904754",
                                        "billable": true,
                                        "chatStartTime": "2025-05-02T20:44:54.903"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "2022 Chevy Blazer RS",
                                "chats": [
                                    {
                                        "chat_id": "23925076",
                                        "billable": true,
                                        "chatStartTime": "2025-05-10T02:05:16.7"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "2023 Chevy Traverse",
                                "chats": [
                                    {
                                        "chat_id": "23898931",
                                        "billable": true,
                                        "chatStartTime": "2025-04-30T21:29:35.79"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "Silverado",
                                "chats": [
                                    {
                                        "chat_id": "23902686",
                                        "billable": true,
                                        "chatStartTime": "2025-05-02T03:44:20.687"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "Hummer",
                                "chats": [
                                    {
                                        "chat_id": "23906754",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T19:10:55.15"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "Chevrolet",
                                "chats": [
                                    {
                                        "chat_id": "23954864",
                                        "billable": true,
                                        "chatStartTime": "2025-05-20T12:42:51.297"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "Toyota",
                                "chats": [
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    }
                                ],
                                "count": 1
                            }
                        ],
                        "representation": 1,
                        "title": "Most Asked Vehicles"
                    },
                    "most_asked_vehicle_features": {
                        "data": [
                            {
                                "data": "dependable",
                                "chats": [
                                    {
                                        "chat_id": "23902062",
                                        "billable": true,
                                        "chatStartTime": "2025-05-01T21:23:39.073"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "test drive",
                                "chats": [
                                    {
                                        "chat_id": "23902686",
                                        "billable": true,
                                        "chatStartTime": "2025-05-02T03:44:20.687"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "financing",
                                "chats": [
                                    {
                                        "chat_id": "23907132",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:19:44.437"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "cash payment",
                                "chats": [
                                    {
                                        "chat_id": "23902062",
                                        "billable": true,
                                        "chatStartTime": "2025-05-01T21:23:39.073"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "low monthly payments",
                                "chats": [
                                    {
                                        "chat_id": "23977551",
                                        "billable": false,
                                        "chatStartTime": "2025-05-27T22:49:36.597"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "3rd row option",
                                "chats": [
                                    {
                                        "chat_id": "23983898",
                                        "billable": false,
                                        "chatStartTime": "2025-05-29T19:05:38.557"
                                    }
                                ],
                                "count": 1
                            }
                        ],
                        "representation": 1,
                        "title": "Most Asked Vehicle Features"
                    },
                    "finance_leasing_inquiries": {
                        "data": [
                            {
                                "data": "financing options",
                                "chats": [
                                    {
                                        "chat_id": "23907132",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:19:44.437"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "down payment",
                                "chats": [
                                    {
                                        "chat_id": "23907132",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:19:44.437"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "trade-in",
                                "chats": [
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    },
                                    {
                                        "chat_id": "23954911",
                                        "billable": true,
                                        "chatStartTime": "2025-05-20T13:02:55.52"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "financing plans",
                                "chats": [
                                    {
                                        "chat_id": "23963808",
                                        "billable": false,
                                        "chatStartTime": "2025-05-22T21:37:49.787"
                                    }
                                ],
                                "count": 1
                            }
                        ],
                        "representation": 1,
                        "title": "Finance & Leasing Inquiries"
                    },
                    "trade_in_questions": {
                        "data": [
                            {
                                "data": "trade-in value",
                                "chats": [
                                    {
                                        "chat_id": "23904754",
                                        "billable": true,
                                        "chatStartTime": "2025-05-02T20:44:54.903"
                                    },
                                    {
                                        "chat_id": "23898248",
                                        "billable": true,
                                        "chatStartTime": "2025-04-30T17:56:27.76"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "trade-in vehicle assessment",
                                "chats": [
                                    {
                                        "chat_id": "23907132",
                                        "billable": true,
                                        "chatStartTime": "2025-05-03T23:19:44.437"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "what's the trade-in value?",
                                "chats": [
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    },
                                    {
                                        "chat_id": "23954911",
                                        "billable": true,
                                        "chatStartTime": "2025-05-20T13:02:55.52"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "do you take trade-ins?",
                                "chats": [
                                    {
                                        "chat_id": "23955499",
                                        "billable": false,
                                        "chatStartTime": "2025-05-20T15:31:55.86"
                                    }
                                ],
                                "count": 1
                            }
                        ],
                        "representation": 1,
                        "title": "Trade-In Questions"
                    },
                    "escalation_rate_to_sales_rep": {
                        "data": [
                            {
                                "data": "Yes",
                                "chats": [
                                    {
                                        "chat_id": "23898248",
                                        "billable": true,
                                        "chatStartTime": "2025-04-30T17:56:27.76"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "No",
                                "chats": [
                                    {
                                        "chat_id": "23907584",
                                        "billable": false,
                                        "chatStartTime": "2025-05-04T06:51:52.89"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "sales inquiry",
                                "chats": [
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    },
                                    {
                                        "chat_id": "23954911",
                                        "billable": true,
                                        "chatStartTime": "2025-05-20T13:02:55.52"
                                    }
                                ],
                                "count": 2
                            },
                            {
                                "data": "follow-up appointment",
                                "chats": [
                                    {
                                        "chat_id": "23963808",
                                        "billable": false,
                                        "chatStartTime": "2025-05-22T21:37:49.787"
                                    }
                                ],
                                "count": 1
                            }
                        ],
                        "representation": 0,
                        "title": "Escalation Rate to Sales Rep"
                    },
                    "popular_price_ranges_searched": {
                        "data": [
                            {
                                "data": "2000-2500",
                                "chats": [
                                    {
                                        "chat_id": "23902062",
                                        "billable": true,
                                        "chatStartTime": "2025-05-01T21:23:39.073"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "400 monthly",
                                "chats": [
                                    {
                                        "chat_id": "23902062",
                                        "billable": true,
                                        "chatStartTime": "2025-05-01T21:23:39.073"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "$15000 or less",
                                "chats": [
                                    {
                                        "chat_id": "23980749",
                                        "billable": true,
                                        "chatStartTime": "2025-05-28T20:25:16.523"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "$3000",
                                "chats": [
                                    {
                                        "chat_id": "23983177",
                                        "billable": true,
                                        "chatStartTime": "2025-05-29T15:54:57.773"
                                    }
                                ],
                                "count": 1
                            }
                        ],
                        "representation": 1,
                        "title": "Popular Price Ranges Searched"
                    },
                    "appointment_requests": {
                        "data": [
                            {
                                "data": "schedule a test drive",
                                "chats": [
                                    {
                                        "chat_id": "23902686",
                                        "billable": true,
                                        "chatStartTime": "2025-05-02T03:44:20.687"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "schedule service",
                                "chats": [
                                    {
                                        "chat_id": "23918269",
                                        "billable": true,
                                        "chatStartTime": "2025-05-07T20:18:36.823"
                                    }
                                ],
                                "count": 1
                            },
                            {
                                "data": "set up an appointment",
                                "chats": [

                                ],
                                "count": 0
                            },
                            {
                                "data": "schedule follow-up",
                                "chats": [
                                    {
                                        "chat_id": "23950392",
                                        "billable": true,
                                        "chatStartTime": "2025-05-19T02:53:50.78"
                                    }
                                ],
                                "count": 1
                            }
                        ],
                        "representation": 1,
                        "title": "Appointment Requests"
                    },
                    "total_chats_processed": 97,
                    "total_input_tokens": 20760,
                    "total_output_tokens": 3754,
                    "total_cost": "0.054152"
                }
            }
        ]
        console.log(data, "+++++++++++++++++++++++++++++++++++++++++++++++++++++++")
        console.log(data?.[0]?.["167"], "--------------------------------------------")
        const extracted: any = data?.[0]?.["167"]; // you may want to make this dynamic
        //   const chartKeys = Object.keys(extracted).filter(k => typeof extracted[k] === "object" && extracted[k]?.data);

        if (!extracted || typeof extracted !== "object") {
            return <div>No insights available.</div>;
        }

        // Filter out metadata keys and ensure the structure has chartable content
        const chartKeys = Object.keys(extracted).filter((key) => {
            const item = extracted[key];
            return (
                typeof item === "object" &&
                item !== null &&
                "representation" in item &&
                "data" in item &&
                Array.isArray(item.data)
            );
        });
        setExtractedKey(extracted)
        console.log("=====================================")
        console.log(chartKeys)
        console.log("=====================================")
        setGetReport(chartKeys)
        // const reportData = await wglcsApiService.getjsondata(params);
        // if (reportData?.data?.data) {
        //     setGetReport(reportData?.data?.data);
        //     setHideButton(false);
        // }
        setLoading(false);
    };
    const renderLoader = () => {
        return (
            <ProgressSpinner strokeWidth="3" fill="#EEEEEE" style={{ height: "20px", width: "20px", marginTop: "2px" }} animationDuration=".5s" />

        );
    };
    const mappedData = getreport?.askedVehicles?.map((item) => ({
        name: item.data, // Vehicle name
        y: item.count, // Count
    }));
    // const AskedVehiclesGraph = {
    //     chart: {
    //         type: "column",
    //         backgroundColor: utils.isDarkMode() ? "#000000" : "white",
    //     },
    //     title: {
    //         text: t("GraphReports-label.Asked-Vehicles"),
    //         align: "center",
    //         style: {
    //             fontSize: "16px",
    //             color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //         },
    //     },
    //     xAxis: {
    //         categories: mappedData?.map((item) => item.name),
    //         title: {
    //             style: {
    //                 color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //             },
    //         },
    //         labels: {
    //             step: 1, // Show all labels
    //             style: {
    //                 color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //             },
    //         },
    //         lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //         accessibility: {
    //             description: "Countries",
    //         },
    //     },
    //     yAxis: {
    //         title: {
    //             text: t("GraphReports-label.Values"),
    //             style: {
    //                 color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //             },
    //         },
    //         labels: {
    //             style: {
    //                 color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //             },
    //         },
    //         lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //     },
    //     plotOptions: {
    //         series: {
    //             borderWidth: 0,
    //             dataLabels: {
    //                 enabled: true,
    //                 format: "{point.y}",
    //                 style: {
    //                     fontSize: "8px", // Adjust the font size here
    //                 },
    //             },
    //         },
    //         column: {
    //             pointPadding: 0.25,
    //             borderWidth: 0,
    //         },
    //     },
    //     series: [
    //         {
    //             name: t("GraphReports-label.Vehicles"),
    //             colorByPoint: true,
    //             data: mappedData, // Pass mapped data here
    //             events: {
    //                 click: function (event) {
    //                     openAskedVehicleSidebar(event.point); // Pass the clicked data point
    //                 },
    //             },
    //         },
    //     ],
    // };
    // Map rawData to the Highcharts format
    const openAskedVehicleSidebar = (point, formattedData, title) => {
        const selectedData = formattedData?.find((item) => item.name === point.category);
        setGetChatID(selectedData);
        setSelectedHeading(`${t("DashboardReports.ChatsAI-Insights")} > ${title} > ${selectedData.name}`);
        setVisibleSidebar(true);
    };
    // const formattedData = getreport?.trendingKeywords?.map((item) => ({
    //     chats: item.chats,
    //     name: item.data, // Label for each slice
    //     y: item.count, // Value for each slice
    // }));
    // const trendingKeywordsGraph = {
    //     chart: {
    //         spacing: [40, 5, 40, 5],
    //         type: "pie",
    //         backgroundColor: utils.isDarkMode() ? "#000000" : "white",
    //         custom: {},
    //         events: {
    //             render(this: Highcharts.Chart) {
    //                 const chart = this,
    //                     series = chart.series[0];
    //                 const chartOptions: any = chart.options.chart; // Safely access chart options

    //                 if (!chartOptions?.custom) {
    //                     chartOptions!.custom = {}; // Initialize if not defined
    //                 }

    //                 let customLabel: any = chartOptions.custom.label;

    //                 if (!customLabel) {
    //                     customLabel = chartOptions.custom.label = chart.renderer
    //                         .label(
    //                             `<strong>${trendingKeyword}</strong>`,
    //                             0, // x-coordinate placeholder
    //                             0
    //                         )
    //                         .css({
    //                             color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //                             textAnchor: "middle",
    //                         })
    //                         .add();
    //                 }
    //                 const x = series.center[0] + chart.plotLeft,
    //                     y = series.center[1] + chart.plotTop - customLabel.attr("height") / 2;

    //                 customLabel.attr({
    //                     x,
    //                     y,
    //                 });
    //                 // Set font size based on chart diameter
    //                 customLabel.css({
    //                     fontSize: `${series.center[8] / 12}px`,
    //                 });
    //             },
    //         },
    //     },
    //     accessibility: {
    //         point: {
    //             valueSuffix: "%",
    //         },
    //     },
    //     title: {
    //         text: "",
    //         // align: 'left',
    //         // style: {
    //         //     fontSize: '16px', color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
    //         // }
    //     },
    //     tooltip: {
    //         pointFormat: "{series.name}: <b>{point.y}</b>",
    //     },
    //     legend: {
    //         enabled: true,
    //     },
    //     plotOptions: {
    //         pie: {
    //             allowPointSelect: true,
    //             cursor: "pointer",
    //             dataLabels: {
    //                 enabled: true,
    //                 format: "{point.y}",
    //                 style: {
    //                     fontSize: "12px",
    //                     fontWeight: "normal",
    //                     color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //                 },
    //                 distance: -15, // Adjust position closer to the center
    //             },
    //             showInLegend: true, // Ensure the legend is enabled if needed
    //             point: {
    //                 events: {
    //                     click: function (this: any) {
    //                         // Handle click event
    //                         openTrendingSidebar(this.name, this.y, this.chats); // Pass the clicked slice name to the handler
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     series: [
    //         {
    //             name: t("GraphReports-label.Trending-Keywords"),
    //             colorByPoint: true,
    //             innerSize: "72%",
    //             data: formattedData, // Inject the mapped data here
    //         },
    //     ],
    // };
    const openSidebar = (selectedValue, title, selectedChats) => {
        setSelectedHeading(`${t("DashboardReports.ChatsAI-Insights")} > ${title} > ${selectedValue}`);
        var obj = { data: selectedValue, chats: selectedChats };
        setGetChatID(obj);
        setVisibleSidebar(true);
    };

    // // Filter data to exclude items with count === 0
    // const filteredData = getreport?.priceRange?.filter((item) => item.count > 0);
    // const PriceRangeCount = filteredData?.map((item) => item.count);
    // const PriceRangeLabel = filteredData?.map((item) => item.data);

    // const priceRangeGrpah = {
    //     chart: {
    //         type: "pie",
    //         backgroundColor: utils.isDarkMode() ? "#000000" : "white",
    //         spacing: [85, 10, 85, 10],
    //         custom: {},
    //         events: {
    //             render(this: Highcharts.Chart) {
    //                 const chart = this;
    //                 const series = chart.series[0];
    //                 const chartOptions: any = chart.options.chart;

    //                 if (!chartOptions?.custom) {
    //                     chartOptions!.custom = {};
    //                 }

    //                 let customLabel: any = chartOptions.custom.label;

    //                 if (!customLabel) {
    //                     customLabel = chartOptions.custom.label = chart.renderer
    //                         .label(
    //                             `<strong>${t("GraphReports-label.Price-Range")}</strong>`,
    //                             0, // x-coordinate placeholder
    //                             0
    //                         )
    //                         .css({
    //                             color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
    //                             textAnchor: "middle",
    //                         })
    //                         .add();
    //                 }
    //                 const x = series.center[0] + chart.plotLeft,
    //                     y = series.center[1] + chart.plotTop - customLabel.attr("height") / 2;

    //                 customLabel.attr({
    //                     x,
    //                     y,
    //                 });
    //                 // Set font size based on chart diameter
    //                 customLabel.css({
    //                     fontSize: `${series.center[8] / 12}px`,
    //                 });
    //                 // Define labels
    //                 const labels = PriceRangeLabel;
    //                 const count = PriceRangeCount;
    //                 const colors = ["#33ff57", "#3357ff", "#ff33a1", "#ffa833", "#ff3333", "#7ABA78"];
    //                 // Draw circles attached to the ring
    //                 const centerX = series.center[0] + chart.plotLeft;
    //                 const centerY = series.center[1] + chart.plotTop;
    //                 const outerRadius = series.center[2] / 2; // Use the outer edge of the pie chart's inner radius
    //                 const circleCount = count?.length; // Number of circles to attach to the ring
    //                 const circleRadius = 25; // Size of the smaller circles

    //                 // Clear existing circles (if re-rendering)
    //                 if (chartOptions.custom.circles) {
    //                     chartOptions.custom.circles.forEach((circle: Highcharts.SVGElement) => circle.destroy());
    //                 }
    //                 chartOptions.custom.circles = [];

    //                 for (let i = 0; i < circleCount; i++) {
    //                     const angle = (i / circleCount) * Math.PI * 2; // Evenly distribute angles
    //                     const circleX = centerX + outerRadius * Math.cos(angle);
    //                     const circleY = centerY + outerRadius * Math.sin(angle);

    //                     const circle = chart.renderer
    //                         .circle(circleX, circleY, circleRadius)
    //                         .attr({
    //                             fill: colors[i % colors.length], // Random color brightness
    //                             zIndex: 8,
    //                             cursor: 'pointer'
    //                         })
    //                         .add();
    //                     circle.element.addEventListener("click", () => {
    //                         openPriceRnageSidebar(filteredData[i],); // Pass the clicked label to the sidebar
    //                     });

    //                     chartOptions.custom.circles.push(circle);

    //                     // Add a label for each circle
    //                     chart.renderer
    //                         .text(
    //                             count[i % count.length] || "count", // Use label or default
    //                             circleX - 4, // Center the text horizontally at circleX
    //                             circleY + 4 // Slightly adjust vertical positioning
    //                         )
    //                         .css({
    //                             color: "#000", // Text color
    //                             fontSize: "15px", // Font size
    //                         })
    //                         .attr({
    //                             zIndex: 10, // Higher zIndex to place the text in front of the circle
    //                         })
    //                         .add();
    //                     // Calculate label position outside the circle
    //                     const labelDistance = circleRadius + 30; // Distance from the circle edge
    //                     let labelX = circleX + (outerRadius + labelDistance) * Math.cos(angle);
    //                     let labelY = circleY + (outerRadius + labelDistance) * Math.sin(angle);

    //                     let lineDirection = "";
    //                     if (angle >= 0 && angle < Math.PI / 2) {
    //                         // Top-right quadrant
    //                         labelX = circleX + labelDistance * Math.cos(angle);
    //                         labelY = circleY + labelDistance * Math.sin(angle);
    //                         lineDirection = "right";
    //                     } else if (angle >= Math.PI / 2 && angle < Math.PI) {
    //                         // Top-left quadrant
    //                         labelX = circleX + labelDistance * Math.cos(angle);
    //                         labelY = circleY + labelDistance * Math.sin(angle);
    //                         lineDirection = "left";
    //                     } else if (angle >= Math.PI && angle < (3 * Math.PI) / 2) {
    //                         // Bottom-left quadrant
    //                         labelX = circleX + labelDistance * Math.cos(angle);
    //                         labelY = circleY + labelDistance * Math.sin(angle);
    //                         lineDirection = "left";
    //                     } else {
    //                         // Bottom-right quadrant
    //                         labelX = circleX + labelDistance * Math.cos(angle);
    //                         labelY = circleY + labelDistance * Math.sin(angle);
    //                         lineDirection = "right";
    //                     }
    //                     const textX = centerX + (outerRadius + labelDistance) * Math.cos(angle);
    //                     const textY = centerY + (outerRadius + labelDistance) * Math.sin(angle);
    //                     // Adjustments for quadrant-specific placement
    //                     const textOffsetX = angle > Math.PI ? -20 : 20; // Offset for left or right alignment
    //                     const textOffsetY = -15; // Vertical alignment adjustment for better readability
    //                     // Draw the value outside the circle
    //                     chart.renderer
    //                         .text(
    //                             labels[i].toString(), // Value to display
    //                             textX + (angle > Math.PI ? -10 : 10), // Adjust X for alignment
    //                             textY + (angle > Math.PI ? +20 : 20) // textX + textOffsetX, // Adjusted X position
    //                             // textY + textOffsetY // Adjusted Y position
    //                         )
    //                         .css({
    //                             color: utils.isDarkMode() ? "#FFFFFF" : "#000000", // Ensure visibility of text
    //                             fontSize: "10px",
    //                             fontWeight: "500",
    //                             textAnchor: angle > Math.PI ? "end" : "start",
    //                         })
    //                         .attr({
    //                             zIndex: 10, // Ensure text appears on top
    //                             // align: angle > Math.PI ? 'right' : 'left', // Adjust alignment based on position
    //                         })
    //                         .add();

    //                     const lineStartX = centerX + (outerRadius + circleRadius) * Math.cos(angle);
    //                     const lineStartY = centerY + (outerRadius + circleRadius) * Math.sin(angle);
    //                     let lineEndX = labelX;
    //                     const lineEndY = labelY;

    //                     chart.renderer
    //                         .path([
    //                             ["M", lineStartX, lineStartY], // Start of the line
    //                             ["L", lineEndX, lineEndY], // Line to the label's position
    //                             ["L", labelX + textOffsetX / 2, labelY + 12 + textOffsetY / 8], // Line to label
    //                         ])
    //                         .attr({
    //                             stroke: utils.isDarkMode() ? "#FFFFFF" : "#000000", // Arrow color
    //                             "stroke-width": 1.5,
    //                             zIndex: 8, // Behind the label
    //                         })
    //                         .add();
    //                 }
    //             },
    //         },
    //     },
    //     accessibility: {
    //         point: {
    //             valueSuffix: "%",
    //         },
    //     },
    //     title: {
    //         text: "",
    //     },
    //     tooltip: {
    //         enabled: false, // Disable tooltips completely
    //     },
    //     plotOptions: {
    //         // center: ['50%', '70%'], // Adjust center [x, y]
    //         series: {
    //             allowPointSelect: false,
    //             cursor: "pointer",
    //             borderRadius: 4,
    //             dataLabels: [
    //                 {
    //                     enabled: false,
    //                     distance: 5,
    //                     format: "{point.name}",
    //                 },
    //                 {
    //                     enabled: false,
    //                     // distance: 25,
    //                     // format: '{point.percentage:.0f}%',
    //                     // style: {
    //                     //     fontSize: '0.8em'
    //                     // }
    //                 },
    //             ],
    //             showInLegend: false,
    //         },
    //     },
    //     series: [
    //         {
    //             innerSize: "93%",
    //             data: [
    //                 {
    //                     name: "",
    //                     y: 100,
    //                     // color: 'transparent' // Invisible slice
    //                     color: utils.isDarkMode() ? "#555555" : "#D7D3BF",
    //                     //color:"#ECEBDE"
    //                 },
    //             ],
    //         },
    //     ],
    // };
    const openPriceRnageSidebar = (value, title) => {
        setGetChatID(value);
        setSelectedHeading(`${t("DashboardReports.ChatsAI-Insights")} > ${title} > ${value.data}`);
        setVisibleSidebar(true);
    };
    const handleSelect = (data: any, title) => {
        debugger
        setGetChatID(data);
        setSelectedHeading(`${t("DashboardReports.ChatsAI-Insights")} >${title} > ${data.data}`);
        setVisibleSidebar(true);
    };
    const handleSelectServiceAppointment = (data: any) => {
        setGetChatID(data);
        setSelectedHeading(`${t("DashboardReports.ChatsAI-Insights")} > ${t("StaticReport-Text.Service-Appointments")} > ${data.data}`);
        setVisibleSidebar(true);
    };
    const ServiceQuestionCard = () => {
        return (
            <>
                {getreport?.serviceAppointment?.map((data, index) => (
                    <div className="insights-card" key={index}>
                        <span className="insightsCard-span">{data.data}</span>
                        <span className="insight-cardcount" onClick={() => handleSelectServiceAppointment(data)}>{data.count}</span>
                    </div>
                ))}
            </>
        );
    };

    // const FrequentlyQuestionCard = () => {
    //     return (
    //         <>
    //             {getreport?.frequentlyAskedQuestions?.map((data, index) => (
    //                 <div className="insights-card" key={index}>
    //                     <span className="insightsCard-span">{data.data}</span>
    //                     <span className="insight-cardcount" onClick={() => handleSelect(data)}>{data.count}</span>
    //                 </div>
    //             ))}
    //         </>
    //     );
    // };
    const handleSelectVisitorUrl = (data: any) => {
        setGetChatID(data);
        setSelectedHeading(`${t("DashboardReports.ChatsAI-Insights")} > ${t("StaticReport-Text.TopVisited-URL's")} > ${data.data}`);
        setVisibleSidebar(true);
    };
    const VisitorUrlCard = () => {
        return (
            <>
                {getreport?.visitedUrls?.map((data, index) => (
                    <div className="insights-card" key={index}>
                        <span className="insightsCard-span">{data.data}</span>
                        <span className="insight-cardcount" onClick={() => handleSelectVisitorUrl(data)}>{data.count}</span>
                    </div>
                ))}
            </>
        );
    };

    const hideSidebar = () => {
        setVisibleSidebar(false);
        setSelectedHeading("");
    };
    const handleDate = (e) => {
        setselecteddate(e.value);
    };

    // Calculate the current and previous year
    const currentYear = new Date().getFullYear();
    const yearRange = `${currentYear - 1}:${currentYear}`; // Example: "2024:2025" 
    // return (
    //     <>
    //         <div className="row p-2">
    //             <img
    //                 id="logoImage"
    //                 style={{ display: "none" }}
    //                 src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO}
    //                 alt=""
    //             />
    //             <div className="row" style={{ display: "none" }}>
    //                 <div id="textImage" className="col-12 text-center">
    //                     <div className="wgreport-span">{t("DashboardReports.ChatsAI-Insights")}</div>
    //                     <div className="wgreport-span">{selectedWebsite?.domainName}({moment(
    //                         Array.isArray(selecteddate)
    //                             ? selecteddate[0] // Use the first date in the array if it's an array
    //                             : selecteddate || new Date() // Default to today's date if undefined or invalid
    //                     ).format("MMMM-YYYY")})</div>
    //                 </div>
    //             </div>
    //             <div className="wgreport-tab viewreport-box">
    //                 <div className="row view-wgreport ">
    //                     <div className="col-md-3 col-lg-3 py-1 wgreport">
    //                         <label className="wgreport-label">{t("StaticReport-Text.Month")}</label>
    //                         <Calendar
    //                             showIcon
    //                             id="monthpicker"
    //                             placeholder={t("StaticReport-Text.Select-Date")}
    //                             value={selecteddate}
    //                             onChange={handleDate}
    //                             view="month"
    //                             dateFormat="mm/yy"
    //                             yearNavigator
    //                             yearRange={yearRange}
    //                         />
    //                     </div>
    //                     <div className="col-md-3 col-lg-3 py-1 wgreport">
    //                         <label className="wgreport-label" htmlFor="basic">
    //                             {t('Resource Pool.Websites')}
    //                         </label>
    //                         <div className="spinner-box">
    //                             <Dropdown
    //                                 className="form-control"
    //                                 filter
    //                                 showFilterClear
    //                                 filterBy="domainName"
    //                                 value={selectedWebsite}
    //                                 options={WebsiteArray}
    //                                 onChange={onWebsiteChange}
    //                                 optionLabel="domainName"
    //                                 itemTemplate={WebsiteOptionTemplate}
    //                                 placeholder={!loadingWebsite ? t("ReportComponent.Select Website") : selectedWebsite}
    //                             />
    //                             {loadingWebsite && renderLoader()}
    //                         </div>
    //                     </div>

    //                     <div className="col-lg-6 py-1 text-right text-lg-left">
    //                         <button title={t("wg-buttons.View-Report")} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => submit()}>
    //                             {" "}
    //                             <Ripple />
    //                             {t("wg-buttons.View-Report")}
    //                         </button>
    //                         {hidebutton == false ? (
    //                             <>
    //                                 {" "}
    //                                 <button
    //                                     title={t("wg-buttons.Export-PDF")}
    //                                     className="btn-width wgreport-btn wgbtn p-ripple"
    //                                     onClick={() => ExportPDF()}
    //                                 >
    //                                     {" "}
    //                                     <Ripple />
    //                                     {exportloading ? (
    //                                         <ProgressSpinner
    //                                             style={{ width: "25px", bottom: "10px" }}
    //                                             strokeWidth="3"
    //                                             fill="#EEEEEE"
    //                                             animationDuration=".5s"
    //                                         />
    //                                     ) : (
    //                                         t("wg-buttons.Export-PDF")
    //                                     )}
    //                                 </button>
    //                             </>
    //                         ) : (
    //                             ""
    //                         )}
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>

    //         <div id="insight-report">
    //             {loading == true ? (
    //                 <div style={{ textAlign: "center", marginTop: "20%" }}>
    //                     <ProgressSpinner style={{ width: "50px", position: "relative" }} strokeWidth="3" fill="#EEEEEE" animationDuration=".5s" />
    //                 </div>
    //             ) : getreport.length == 0 ? (
    //                 <div className="row p-2">
    //                     <div className="viewreport-box" style={{ height: "450px" }}>
    //                         <h6 className="wgreport_heading" style={{ marginTop: "20%" }}>
    //                             {t("GraphReports-label.NoData-Display")}
    //                         </h6>
    //                     </div>
    //                 </div>
    //             ) : (
    //                 <>
    //                     <div id="section1">
    //                         <div className="row p-2">
    //                             <div
    //                                 style={{
    //                                     background: utils.isDarkMode() ? "#000000" : "aliceblue",
    //                                     border: utils.isDarkMode() ? "1px solid black" : "1px solid green",
    //                                 }}
    //                                 className="col-md-12 wgreport-tab viewreport-box"
    //                             >
    //                                 <div className="insights-label">
    //                                     <label>{t("StaticReport-Text.TotalChats-Processed")}:</label>
    //                                     <label>{getreport?.totalChatsProcessed}</label>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                         {manageState == true ? (
    //                             <></>
    //                         ) : (
    //                             <div className="row">
    //                                 <div className="col-md-6 wgreport-tab">
    //                                     <div className="viewreport-box">
    //                                         <div className="viewreport-box-scroll">
    //                                             {getreport?.trendingKeywords?.length > 0 ? (
    //                                                 <HighchartsReact highcharts={Highcharts} options={trendingKeywordsGraph} />
    //                                             ) : (
    //                                                 <>
    //                                                     <label

    //                                                     >
    //                                                         {t("GraphReports-label.Trending-Keywords")}
    //                                                     </label>
    //                                                     <h6 className="wgreport_heading" >
    //                                                         {t("GraphReports-label.NoData-Display")}
    //                                                     </h6>
    //                                                 </>
    //                                             )}
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                                 <div className="col-md-6 wgreport-tab">
    //                                     <div className="viewreport-box">
    //                                         <div className="viewreport-box-scroll">
    //                                             {getreport?.priceRange?.length > 0 ? (
    //                                                 <HighchartsReact highcharts={Highcharts} options={priceRangeGrpah} />
    //                                             ) : (
    //                                                 <>
    //                                                     <label

    //                                                     >
    //                                                         {t("GraphReports-label.Price-Range")}
    //                                                     </label>
    //                                                     <h6 className="wgreport_heading" >
    //                                                         {t("GraphReports-label.NoData-Display")}
    //                                                     </h6>
    //                                                 </>
    //                                             )}
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         )}
    //                         <div className="row">
    //                             <div className="col-md-6 wgreport-tab">
    //                                 <div className="viewreport-box">
    //                                     <div className="viewreport-box-scroll">

    //                                         {getreport?.frequentlyAskedQuestions?.length > 0 && (
    //                                             <img className="insight-image" src={process.env.PUBLIC_URL + "/css/icons/question.svg"} />
    //                                         )}
    //                                         <label className="label" >
    //                                             {t("StaticReport-Text.FrequentlyAsked-Question")}
    //                                         </label>

    //                                         {getreport?.frequentlyAskedQuestions?.length > 0 ? (
    //                                             <> {FrequentlyQuestionCard()}</>
    //                                         ) : (
    //                                             <h6 className="wgreport_heading" >
    //                                                 {t("GraphReports-label.NoData-Display")}
    //                                             </h6>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                             <div className="col-md-6 wgreport-tab">
    //                                 <div className="viewreport-box">
    //                                     <div className="viewreport-box-scroll">
    //                                         {getreport?.askedVehicles?.length > 0 ? (
    //                                             <HighchartsReact highcharts={Highcharts} options={AskedVehiclesGraph} />
    //                                         ) : (
    //                                             <>
    //                                                 <label

    //                                                 >
    //                                                     {t("GraphReports-label.Asked-Vehicles")}
    //                                                 </label>
    //                                                 <h6 className="wgreport_heading" >
    //                                                     {t("GraphReports-label.NoData-Display")}
    //                                                 </h6>
    //                                             </>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                         <div className="row">
    //                             <div className="col-md-6 wgreport-tab">
    //                                 <div className="viewreport-box">
    //                                     <div className="viewreport-box-scroll">

    //                                         {getreport?.serviceAppointment?.length > 0 && (
    //                                             <img className="insight-image1" src={process.env.PUBLIC_URL + "/css/icons/calender.svg"} />
    //                                         )}
    //                                         <label className="label" >
    //                                             {t("StaticReport-Text.Service-Appointments")}
    //                                         </label>

    //                                         {getreport?.serviceAppointment?.length > 0 ? (
    //                                             <> {ServiceQuestionCard()}</>
    //                                         ) : (
    //                                             <h6 className="wgreport_heading" >
    //                                                 {t("GraphReports-label.NoData-Display")}
    //                                             </h6>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                             <div className="col-md-6 wgreport-tab">
    //                                 <div className="viewreport-box">
    //                                     <div className="viewreport-box-scroll">

    //                                         {getreport?.visitedUrls?.length > 0 && (
    //                                             <img className="insight-image1" src={process.env.PUBLIC_URL + "/css/icons/link.svg"} />
    //                                         )}
    //                                         <label className="label">
    //                                             {t("StaticReport-Text.TopVisited-URL's")}{" "}
    //                                         </label>

    //                                         {getreport?.visitedUrls?.length > 0 ? (
    //                                             <> {VisitorUrlCard()}</>
    //                                         ) : (
    //                                             <h6 className="wgreport_heading" >
    //                                                 {t("GraphReports-label.NoData-Display")}
    //                                             </h6>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                     {visiblesidebar && <RightSideBar visible={visiblesidebar} close={hideSidebar} path={selectedHeading} getchats={getchatID} />}
    //                 </>
    //             )}
    //         </div>
    //     </>
    // );
    const getPieChart = (formattedData, title) => {
        return {
            chart: {
                type: 'pie',
                backgroundColor: utils.isDarkMode() ? '#000000' : 'white',
            },
            title: { text: null },
            tooltip: {
                valueSuffix: '%'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    colorByPoint: true,
                    dataLabels: [
                        {
                            enabled: true,
                            format: '{point.name}',
                            distance: 20,
                            connectorShape: 'crookedLine',
                            style: {
                                fontSize: '1.1em',
                                color: "black"
                                // textOutline: 'none'
                            },
                        },
                        {
                            enabled: true,
                            distance: -40,
                            format: '{point.percentage:.1f}%',
                            style: {
                                fontSize: '1.2em',
                                textOutline: 'none',
                                color: "black"
                                // opacity: 0.7
                            },
                        }
                    ],
                    point: {
                        events: {
                            click: function (this: any) {
                                console.log("Slice clicked:", this.name, this.y, this.percentage);
                                openSidebar(this.name, title, this.chats);
                            }
                        }
                    },
                }
            },
            series: [
                {
                    name: 'Count',
                    colorByPoint: true,
                    data: formattedData
                },
            ],
        };

    }
    const getDonutChart = (formattedData, title) => {
        return {
            chart: {
                spacing: [40, 5, 40, 5],
                type: "pie",
                backgroundColor: utils.isDarkMode() ? "#000000" : "white",
                custom: {},
                events: {
                    render(this: Highcharts.Chart) {
                        const chart = this,
                            series = chart.series[0];
                        const chartOptions: any = chart.options.chart; // Safely access chart options

                        if (!chartOptions?.custom) {
                            chartOptions!.custom = {}; // Initialize if not defined
                        }
                    },
                },
            },
            accessibility: {
                point: {
                    valueSuffix: "%",
                },
            },
            title: {
                text: "",
            },
            tooltip: {
                pointFormat: "{series.name}: <b>{point.y}</b>",
            },
            legend: {
                enabled: true,
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: "pointer",
                    dataLabels: {
                        enabled: true,
                        format: "{point.y}",
                        style: {
                            fontSize: "12px",
                            fontWeight: "normal",
                            color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
                        },
                        distance: -15, // Adjust position closer to the center
                    },
                    showInLegend: true, // Ensure the legend is enabled if needed
                    point: {
                        events: {
                            click: function (this: any) {
                                // Handle click event
                                openSidebar(this.name, title, this.chats); // Pass the clicked slice name to the handler
                            },
                        },
                    },
                },
            },
            series: [
                {
                    name: t("GraphReports-label.Trending-Keywords"),
                    colorByPoint: true,
                    innerSize: "72%",
                    data: formattedData, // Inject the mapped data here
                },
            ],

        }
    }
    const getbarChart = (formattedData, title) => {
        return {
            chart: { type: 'column', backgroundColor: utils.isDarkMode() ? "#000000" : "white", },
            title: { text: null },
            xAxis: {
                categories: formattedData?.map((item) => item.name),
                title: { text: '' },
            },
            yAxis: {
                title: {
                    text: 'Values',
                    style: {
                        fontSize: "12px",
                        color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
                    },
                },
                labels: {
                    style: {
                        color: utils.isDarkMode() ? "#FFFFFF" : "#000000",
                    },
                },
                lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000",
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: "{point.y}",
                        style: {
                            fontSize: "8px", // Adjust the font size here
                        },
                    },
                },
                column: {
                    pointPadding: 0.25,
                    borderWidth: 0,
                },
            },
            series: [{
                name: 'Vehicles',
                colorByPoint: true,
                data: formattedData,// Pass mapped data here
                events: {
                    click: function (event) {
                        openAskedVehicleSidebar(event.point, formattedData, title); // Pass the clicked data point
                    },
                },
            }],
        }
    }
    const getlineChart = (formattedData, title) => {

    }
    const getCustomDonutChart = (chartItems, title) => {
        const filteredData = chartItems?.filter((item) => item.count > 0);
        const PriceRangeCount = filteredData?.map((item) => item.count);
        const PriceRangeLabel = filteredData?.map((item) => item.data);
        return {
            chart: {
                type: "pie",
                backgroundColor: utils.isDarkMode() ? "#000000" : "white",
                spacing: [85, 10, 85, 10],
                custom: {},
                events: {
                    render(this: Highcharts.Chart) {
                        const chart = this;
                        const series = chart.series[0];
                        const chartOptions: any = chart.options.chart;

                        if (!chartOptions?.custom) {
                            chartOptions!.custom = {};
                        }
                        // Define labels
                        const labels = PriceRangeLabel;
                        const count = PriceRangeCount;
                        const colors = ["#33ff57", "#3357ff", "#ff33a1", "#ffa833", "#ff3333", "#7ABA78"];
                        // Draw circles attached to the ring
                        const centerX = series.center[0] + chart.plotLeft;
                        const centerY = series.center[1] + chart.plotTop;
                        const outerRadius = series.center[2] / 2; // Use the outer edge of the pie chart's inner radius
                        const circleCount = count?.length; // Number of circles to attach to the ring
                        const circleRadius = 25; // Size of the smaller circles

                        // Clear existing circles (if re-rendering)
                        if (chartOptions.custom.circles) {
                            chartOptions.custom.circles.forEach((circle: Highcharts.SVGElement) => circle.destroy());
                        }
                        chartOptions.custom.circles = [];

                        for (let i = 0; i < circleCount; i++) {
                            const angle = (i / circleCount) * Math.PI * 2; // Evenly distribute angles
                            const circleX = centerX + outerRadius * Math.cos(angle);
                            const circleY = centerY + outerRadius * Math.sin(angle);

                            const circle = chart.renderer
                                .circle(circleX, circleY, circleRadius)
                                .attr({
                                    fill: colors[i % colors.length], // Random color brightness
                                    zIndex: 8,
                                    cursor: 'pointer'
                                })
                                .add();
                            circle.element.addEventListener("click", () => {
                                openPriceRnageSidebar(filteredData[i], title); // Pass the clicked label to the sidebar
                            });

                            chartOptions.custom.circles.push(circle);

                            // Add a label for each circle
                            chart.renderer
                                .text(
                                    count[i % count.length] || "count", // Use label or default
                                    circleX - 4, // Center the text horizontally at circleX
                                    circleY + 4 // Slightly adjust vertical positioning
                                )
                                .css({
                                    color: "#000", // Text color
                                    fontSize: "15px", // Font size
                                })
                                .attr({
                                    zIndex: 10, // Higher zIndex to place the text in front of the circle
                                })
                                .add();
                            // Calculate label position outside the circle
                            const labelDistance = circleRadius + 30; // Distance from the circle edge
                            let labelX = circleX + (outerRadius + labelDistance) * Math.cos(angle);
                            let labelY = circleY + (outerRadius + labelDistance) * Math.sin(angle);

                            let lineDirection = "";
                            if (angle >= 0 && angle < Math.PI / 2) {
                                // Top-right quadrant
                                labelX = circleX + labelDistance * Math.cos(angle);
                                labelY = circleY + labelDistance * Math.sin(angle);
                                lineDirection = "right";
                            } else if (angle >= Math.PI / 2 && angle < Math.PI) {
                                // Top-left quadrant
                                labelX = circleX + labelDistance * Math.cos(angle);
                                labelY = circleY + labelDistance * Math.sin(angle);
                                lineDirection = "left";
                            } else if (angle >= Math.PI && angle < (3 * Math.PI) / 2) {
                                // Bottom-left quadrant
                                labelX = circleX + labelDistance * Math.cos(angle);
                                labelY = circleY + labelDistance * Math.sin(angle);
                                lineDirection = "left";
                            } else {
                                // Bottom-right quadrant
                                labelX = circleX + labelDistance * Math.cos(angle);
                                labelY = circleY + labelDistance * Math.sin(angle);
                                lineDirection = "right";
                            }
                            const textX = centerX + (outerRadius + labelDistance) * Math.cos(angle);
                            const textY = centerY + (outerRadius + labelDistance) * Math.sin(angle);
                            // Adjustments for quadrant-specific placement
                            const textOffsetX = angle > Math.PI ? -20 : 20; // Offset for left or right alignment
                            const textOffsetY = -15; // Vertical alignment adjustment for better readability
                            // Draw the value outside the circle
                            chart.renderer
                                .text(
                                    labels[i].toString(), // Value to display
                                    textX + (angle > Math.PI ? -10 : 10), // Adjust X for alignment
                                    textY + (angle > Math.PI ? +20 : 20) // textX + textOffsetX, // Adjusted X position
                                    // textY + textOffsetY // Adjusted Y position
                                )
                                .css({
                                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000", // Ensure visibility of text
                                    fontSize: "10px",
                                    fontWeight: "500",
                                    textAnchor: angle > Math.PI ? "end" : "start",
                                })
                                .attr({
                                    zIndex: 10, // Ensure text appears on top
                                    // align: angle > Math.PI ? 'right' : 'left', // Adjust alignment based on position
                                })
                                .add();

                            const lineStartX = centerX + (outerRadius + circleRadius) * Math.cos(angle);
                            const lineStartY = centerY + (outerRadius + circleRadius) * Math.sin(angle);
                            let lineEndX = labelX;
                            const lineEndY = labelY;

                            chart.renderer
                                .path([
                                    ["M", lineStartX, lineStartY], // Start of the line
                                    ["L", lineEndX, lineEndY], // Line to the label's position
                                    ["L", labelX + textOffsetX / 2, labelY + 12 + textOffsetY / 8], // Line to label
                                ])
                                .attr({
                                    stroke: utils.isDarkMode() ? "#FFFFFF" : "#000000", // Arrow color
                                    "stroke-width": 1.5,
                                    zIndex: 8, // Behind the label
                                })
                                .add();
                        }
                    },
                },
            },
            accessibility: {
                point: {
                    valueSuffix: "%",
                },
            },
            title: {
                text: "",
            },
            tooltip: {
                enabled: false, // Disable tooltips completely
            },
            plotOptions: {

                series: {
                    allowPointSelect: false,
                    cursor: "pointer",
                    borderRadius: 4,
                    dataLabels: [
                        {
                            enabled: false,
                            distance: 5,
                            format: "{point.name}",
                        },
                        {
                            enabled: false,

                        },
                    ],
                    showInLegend: false,
                },
            },
            series: [
                {
                    innerSize: "93%",
                    data: [
                        {
                            name: "",
                            y: 100,
                            color: utils.isDarkMode() ? "#555555" : "#D7D3BF",
                        },
                    ],
                },
            ],
        }
    }
    const getwordCloudChart = (chartItems, title) => {
        const formattedData = chartItems.map(item => ({
            // chats: item.chats,
            name: item.data,
            weight: item.count,
        }));
        return {
            chart: {
                type: 'wordcloud', // ✅ This should be a string, not `Wordcloud`
                zooming: {
                    type: 'xy'
                },
                panning: {
                    enabled: true,
                    type: 'xy'
                },
                panKey: 'shift'
            },
            title: {
                text: "",
            },
            tooltip: {
                headerFormat: '<span style="font-size: 16px"><b>{point.name}</b></span><br>',
                pointFormat: 'Count: <b>{point.weight}</b>'
            },
            plotOptions: {
                wordcloud: {
                    minFontSize: 8,
                    maxFontSize: 12,
                    style: {
                        fontFamily: 'Arial, mono space',
                        fontWeight: 'normal'
                    }
                }
            },
            series: [{
                type: 'wordcloud',
                data: formattedData, // ✅ Correct key should be `data`, not `formattedData`
                name: 'Occurrences'
            }]
        }
    }
    const renderChart = () => {
        return (
            <div className="row">
                {getreport
                    // .filter(key => {
                    //     const chartData = extractedKey[key];
                    //     return chartData && [0, 1, 2, 3, 4, 5, 6].includes(chartData.representation); // Only allow valid charts
                    // })
                    .map((key, index) => {
                        const chartData = extractedKey[key];
                        const { title, data: chartItems, representation } = chartData;

                        const formattedData = chartItems.map(item => ({
                            chats: item.chats,
                            name: item.data,
                            y: item.count,
                        }));

                        return (
                            <>
                                {representation === 0 && (
                                    <>
                                        <div key={index} className="col-md-6 wgreport-tab">
                                            <div className="viewreport-box">
                                                <div style={{ textAlign: "center" }}>
                                                    <label className="label">{title}</label>
                                                </div>
                                                <div className="viewreport-box-scroll">
                                                    <HighchartsReact
                                                        highcharts={Highcharts}
                                                        options={getPieChart(formattedData, title)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {representation === 4 && (
                                    <>
                                        <div key={index} className="col-md-6 wgreport-tab">
                                            <div className="viewreport-box">
                                                <div style={{ textAlign: "center" }}>
                                                    <label className="label">{title}</label>
                                                </div>
                                                <div className="viewreport-box-scroll">
                                                    <HighchartsReact
                                                        highcharts={Highcharts}
                                                        options={getDonutChart(formattedData, title)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>

                                )}
                                {representation === 6 && (
                                    <>
                                        <div key={index} className="col-md-6 wgreport-tab">
                                            <div className="viewreport-box">
                                                <div style={{ textAlign: "center" }}>
                                                    <label className="label">{title}</label>
                                                </div>
                                                <div className="viewreport-box-scroll">
                                                    <HighchartsReact
                                                        highcharts={Highcharts}
                                                        options={getCustomDonutChart(chartItems, title)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {representation === 1 && (
                                    <>
                                        <div key={index} className="col-md-6 wgreport-tab">
                                            <div className="viewreport-box">
                                                <div style={{ textAlign: "center" }}>
                                                    <label className="label">{title}</label>
                                                </div>
                                                <div className="viewreport-box-scroll">
                                                    <HighchartsReact
                                                        highcharts={Highcharts}
                                                        options={getbarChart(formattedData, title)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {representation === 2 && (
                                    <>
                                        <div key={index} className="col-md-6 wgreport-tab">
                                            <div className="viewreport-box">
                                                <div style={{ textAlign: "center" }}>
                                                    <label className="label">{title}</label>
                                                </div>
                                                <div className="viewreport-box-scroll">
                                                    {chartItems.map((data, index) => (
                                                        <div className="insights-card" key={index}>
                                                            <span className="insightsCard-span">{data.data}</span>
                                                            <span className="insight-cardcount" onClick={() => handleSelect(data, title)}>
                                                                {data.count}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {representation === 3 && (
                                    <>
                                        <div key={index} className="col-md-6 wgreport-tab">
                                            <div className="viewreport-box">
                                                <div style={{ textAlign: "center" }}>
                                                    <label className="label">{title}</label>
                                                </div>
                                                <div className="viewreport-box-scroll">
                                                    <HighchartsReact
                                                        highcharts={Highcharts}
                                                        options={getlineChart(formattedData, title)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {representation === 5 && (
                                    <>
                                        <div key={index} className="col-md-6 wgreport-tab">
                                            <div className="viewreport-box">
                                                <div style={{ textAlign: "center" }}>
                                                    <label className="label">{title}</label>
                                                </div>
                                                <div className="viewreport-box-scroll">
                                                    <HighchartsReact
                                                        highcharts={Highcharts}
                                                        options={getwordCloudChart(chartItems, title)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </>
                        );
                    })}
            </div >
        )
    }

    return (
        <>
            <div className="row p-2">
                <div
                    style={{
                        background: utils.isDarkMode() ? "#000000" : "aliceblue",
                        border: utils.isDarkMode() ? "1px solid black" : "1px solid green",
                    }}
                    className="col-md-12 wgreport-tab viewreport-box"
                >
                    <div className="insights-label">
                        <label>{t("StaticReport-Text.TotalChats-Processed")}:</label>
                        <label>{extractedKey?.total_chats_processed}</label>
                    </div>
                </div>
            </div>
            {renderChart()}
            {visiblesidebar && <RightSideBar visible={visiblesidebar} close={hideSidebar} path={selectedHeading} getchats={getchatID} />}
        </>
    )
};
export default InsightsReport;
